// Copyright (c) 2016 Deere & Company

import t from 'tcomb';

const PinsNotRegistered = t.struct({
    account: t.maybe(t.String),
    accountName: t.maybe(t.String),
    amountOfUse: t.maybe(t.Number),
    currentlyOnRent: t.maybe(t.String),
    daysOnRent: t.maybe(t.Number),
    description: t.maybe(t.String),
    invoiceDate: t.maybe(t.Number),
    location: t.maybe(t.String),
    model: t.maybe(t.String),
    pin: t.maybe(t.String),
    reportDate: t.maybe(t.Number)
}, {
    name: 'PinsNotRegistered',
    strict: true
});

export const getDefaultState = () => new PinsNotRegistered({});

export default PinsNotRegistered;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/pins-not-registered.js